<template>
  <v-form v-model="formValid">
    <v-container>
      <v-alert v-if="success" type="success">Настройки успешно сохранены. Изменения вступят в силу после перезагрузки сервера</v-alert>
      <div v-if="loading" class="text-center">
        <v-progress-circular
        indeterminate
        color="primary"
        ></v-progress-circular>
      </div>
      <v-card v-else>
        <v-card-text>
          <LocalServerConfig :localServerConfig="localConfig.local_server" />
          <v-divider></v-divider>
          <RKeeper :rk7Config="localConfig.r_keeper_midserver" />
          <v-divider></v-divider>
          <ProCartConfig :proCartConfig="localConfig.pro_cart_settings" />
          <v-divider></v-divider>
          <rk7RefConfig :rk7RefConfig="localConfig.r_keeper_references" :rk_refs="rk_refs"/>
          <v-divider></v-divider>
          <LogConfig :logConfig="localConfig.log" />
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="updateConfig()" :disabled="!formValid">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-form>
</template>

<script>
import RKeeper from "@/components/Settings/RKeeper";
import LogConfig from "@/components/Settings/LogConfig";
import ProCartConfig from "@/components/Settings/ProCartConfig";
import LocalServerConfig from "@/components/Settings/LocalServerConfig";
import rk7RefConfig from "@/components/Settings/RKeeperReferencesConfig";
export default {
  data() {
    return {
      localConfig: {},
      loading: true,
      rk_refs: null,
      formValid: false,
      success: false,
    };
  },
  async mounted() {
    try {
      await this.prepare();
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  },
  components: {
    RKeeper,
    LogConfig,
    ProCartConfig,
    LocalServerConfig,
    rk7RefConfig,
  },

  computed: {
  },

  methods: {
    async prepare() {
      try {
        await this.$store.dispatch("getConfig");
        await this.$store.dispatch("getConfigData");
        this.localConfig = { ...this.$store.getters.config.response };
        this.rk_refs = {...this.$store.getters.rk_refs.response};

        for (let key in this.rk_refs) {
          this.rk_refs[key].map(x => x['Title'] =  x['Code'] + ': ' + x['Name'])
          this.rk_refs[key].map(x => x['Code'] = parseInt(x['Code']))
        }
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    async updateConfig() {
      try {
        await this.$store.dispatch("updateConfig", this.localConfig);
        window.scrollTo(0, 0)
        this.success = true;
      } catch (e) {
        console.error(e)
      }
    },
  },
};

</script>